import React, { useState } from 'react';
import { useToast } from '@front-activerse/common-components';
import { useNavigate } from 'react-router-dom';
import { useFormikContext } from 'formik';
import { Button, Spinner } from 'reactstrap';
import createRequest from '../helpers/createRequest';
import { goalSettings } from '../types';
import { useTranslator, callNativeMobileApp } from '@front-activerse/common-components';
import useSteps from '../StepContext/useSteps';

const ConfirmButton: React.FC = () => {
  const { t } = useTranslator();
  const { toastError } = useToast();
  const { values, resetForm } = useFormikContext<goalSettings>();
  const [loading, setLoading] = useState(false);
  const { saveGoalSettings } = useSteps();
  const navigate = useNavigate();

  const handleOnClick = async () => {
    setLoading(true);
    try {
      const response: any = await saveGoalSettings(createRequest(values));
      if (response.__typename === 'BasicMutationSuccess') {
        resetForm();
        // old webview navigation - remove after mobile navigation are updated
        callNativeMobileApp({
          action: 'close_webview',
        });

        // new webview navigation
        callNativeMobileApp({
          action: 'refresh_data',
          payload: {
            module: 'diet_settings',
          },
        });
        callNativeMobileApp({
          action: 'close_modal',
        });

        navigate('/goal-settings/');
      }
    } catch (error) {
      toastError();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      color="primary"
      className="w-100"
      type="button"
      onClick={handleOnClick}
      disabled={loading}
    >
      {loading ? (
        <>
          <Spinner size="sm" className="me-2">
            Loading...
          </Spinner>
          {t('goalSettings.summary.processingButton')}
        </>
      ) : (
        t('goalSettings.summary.saveButton')
      )}
    </Button>
  );
};

export default ConfirmButton;
